import React, { useState, useEffect } from "react";
// import { getTheme } from '../utils'
import { XLogo } from "../../icons/logos/XLogo";
import { XText } from "../../icons/logos/XText";
import { FarmLogo } from "../../icons/logos/FarmLogo";
import { FarmText } from "../../icons/logos/FarmText";
import { LoansLogo } from "../../icons/logos/LoansLogo";
import { LoansText } from "../../icons/logos/LoansText";
import { MineLogo } from "../../icons/logos/MineLogo";
import { MineText } from "../../icons/logos/MineText";
import { WrapLogo } from "../../icons/logos/WrapLogo";
import { WrapText } from "../../icons/logos/WrapText";
import { FlareText } from "../../icons/logos/FlareText";
import { Dropdown, ChevronBottomThin } from "../..";
var theme = {
    dropdown: {
        width: "400px",
        disabled: {
            background: "#ccc",
            color: "#fff",
        },
        header: {
            fontFamily: "'Poppins', sans-serif",
            fontSize: "14px",
            background: "transparent",
            lineHeight: "20px",
            title: {
                color: "#fff",
                padding: "0px",
            },
            desc: {
                color: "#fff",
                padding: "5px 10px",
            },
        },
        item: {
            fontFamily: "'Poppins', sans-serif",
            fontSize: "14px",
            title: {
                color: "#fff",
                padding: "0px 10px",
                width: "400px",
            },
            desc: {
                color: "rgba(165, 168, 169, 1)",
                padding: "0px 10px",
                width: "400px",
            },
            background: "rgba(49, 47, 53, 1)",
            padding: "20px 10px !important",
            width: "inherit",
            hoverColor: "black",
            hoverBackground: "rgba(255, 255, 255, 0.4)",
        },
    },
};
var opts = new Map();
opts.set("flarex", {
    title: (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
        React.createElement(FlareText, { size: "mobile" }),
        React.createElement(XText, { size: "mobile", width: 12 }))),
    desc: "Swap currencies and earn passive income.",
    icon: React.createElement(XLogo, { width: 30 }),
});
opts.set("flarefarm", {
    title: (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
        React.createElement(FlareText, { size: "mobile" }),
        React.createElement(FarmText, { size: "mobile" }))),
    desc: (React.createElement(React.Fragment, null,
        React.createElement("span", null, "Stake tokens to earn yield on asset pools."),
        React.createElement("br", null),
        React.createElement("span", null, "Participate in new token launches."))),
    icon: React.createElement(FarmLogo, { width: 30 }),
});
opts.set("flarewrap", {
    title: (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
        React.createElement(FlareText, { size: "mobile" }),
        React.createElement(WrapText, { size: "mobile" }))),
    desc: "Transfer your cryptoassets between blockchain networks.",
    icon: React.createElement(WrapLogo, { width: 30 }),
});
opts.set("flareloans", {
    title: (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
        React.createElement(FlareText, { size: "mobile" }),
        React.createElement(LoansText, { size: "mobile" }))),
    desc: "Leverage your crypto-assets as collateral for loans or to mint stable currency.",
    icon: React.createElement(LoansLogo, { width: 30 }),
});
opts.set("flaremine", {
    title: (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
        React.createElement(FlareText, { size: "mobile" }),
        React.createElement(MineText, { size: "mobile" }))),
    desc: "Mine Spark using BTC and ETH mining rigs.",
    icon: React.createElement(MineLogo, { width: 30 }),
});
export function LogosDropdown(_a) {
    var product = _a.product, productsAndLinks = _a.productsAndLinks, getUrl = _a.getUrl, productWidth = _a.productWidth, productHeight = _a.productHeight, logoWidth = _a.logoWidth, logoHeight = _a.logoHeight;
    var _b = useState(), prd = _b[0], setPrd = _b[1];
    var _c = useState(), lg = _c[0], setLg = _c[1];
    var _d = useState([]), options = _d[0], setOptions = _d[1];
    useEffect(function () {
        var prod = product.toLowerCase();
        var op = [];
        switch (prod) {
            case "flarex":
                setPrd(React.createElement(XText, { width: productWidth || 15, height: productHeight || 21 }));
                setLg(React.createElement(XLogo, { width: logoWidth || 30, height: logoHeight || 36 }));
                break;
            case "flarefarm":
                setPrd(React.createElement(FarmText, { width: productWidth || 51, height: productHeight || 22 }));
                setLg(React.createElement(FarmLogo, { width: logoWidth || 30, height: logoHeight || 36 }));
                break;
            case "flarewrap":
                setPrd(React.createElement(WrapText, { width: productWidth || 57, height: productHeight || 21 }));
                setLg(React.createElement(WrapLogo, { width: logoWidth || 30, height: logoHeight || 36 }));
                break;
            case "flareloans":
                setPrd(React.createElement(LoansText, { width: productWidth || 57, height: productHeight || 21 }));
                setLg(React.createElement(LoansLogo, { width: logoWidth || 30, height: logoHeight || 36 }));
                break;
            case "flaremine":
                setPrd(React.createElement(MineText, { width: productWidth || 50, height: productHeight || 21 }));
                setLg(React.createElement(MineLogo, { width: logoWidth || 30, height: logoHeight || 36 }));
                break;
        }
        opts.forEach(function (v, k) {
            k !== prod && productsAndLinks.find(function (p) { return p.product === k; }) && op.push(v);
        });
        setOptions(op);
    }, [product, productWidth, productHeight, logoWidth, logoHeight]);
    return (React.createElement(Dropdown, { headerOption: {
            title: (React.createElement("div", { style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                } },
                React.createElement(FlareText, { width: 56 }),
                prd,
                React.createElement("div", { style: { marginLeft: "10px" } },
                    React.createElement(ChevronBottomThin, { color: "#fff" })))),
            icon: React.createElement(React.Fragment, null, lg),
        }, theme: theme, options: options, onChange: function (p) { var _a; return getUrl((_a = productsAndLinks[p]) === null || _a === void 0 ? void 0 : _a.url); } }));
}
